import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";

import * as actions from "../../../../store/actions";
import { useInfiniteScroll } from "../../../../utils/pagination";

import NoteList from "./NoteList";
import SearchBox from "../../../../components/formElements/searchbox/SearchBox";
import LoadingSpinner from "../../../../components/uiElements/loadingSpinner/LoadingSpinner";

const Notes = ({
  templates,
  getAllTemplates,
  total_pages,
  searchTemplates,
  searchData,
  searchValue,
  changeView,
  setCurrentId,
  emptyTemplateData,
  apiUtil,
}) => {
  const [page, setPage] = useState(0);

  const loader = useRef(null);

  useEffect(() => {
    if (page > 0 && page <= total_pages && !searchValue) {
      getAllTemplates("", page);
    } else if (
      searchValue &&
      searchValue.length >= 3 &&
      page > 0 &&
      page <= total_pages
    ) {
      getAllTemplates(searchValue, page);
    }
    // eslint-disable-next-line
  }, [page, searchValue]);

  useInfiniteScroll(loader, () => {
    setPage(page => page + 1);
  });

  useEffect(() => {
    emptyTemplateData();
  }, [emptyTemplateData]);

  return (
    <>
      <div className="noteHeader">
        <div className="w-100 pt-3 px-3 pb-0 mt-5">
          <p className=" font-weight-bold text-dark pb-0">
            Note Templates
            <span
              className="float-right text-muted font-weight-normal"
              style={{ cursor: "pointer" }}
            >
              <u
                onClick={() => {
                  changeView(3);
                }}
              >
                Create New
              </u>
            </span>
          </p>
        </div>
        <div className="row notes w-100 mx-auto">
          <div className="col-md-12 w-100 ">
            <SearchBox
              value={searchValue || ""}
              onChange={val => {
                searchTemplates({
                  searchValue: val,
                  total_pages: 1,
                });
                setPage(1);
              }}
            />
          </div>
        </div>
      </div>
      <div className="noteList">
        <NoteList
          templates={templates}
          changeView={changeView}
          setCurrentId={setCurrentId}
        />
      </div>
      <div ref={loader}></div>
      {apiUtil.isLoading && (
        <div className="center-content">
          <LoadingSpinner asOverlay={true} />
        </div>
      )}
    </>
  );
};

const mapStoreToProps = ({ dashboard, validation, api }) => ({
  templates: dashboard.templates.all,
  searchData: dashboard.templates.search,
  searchValue: dashboard.templates.searchValue,
  total_pages: dashboard.templates.total_pages,
  apiUtil: api,
});

const mapDispatchToProps = dispatch => ({
  getAllTemplates: (q, page) => dispatch(actions.getAllTemlates(q, page)),
  searchTemplates: q => dispatch(actions.templateSearch(q)),
  setCurrentId: id => dispatch(actions.setCurrentId(id)),
  emptyTemplateData: () => dispatch(actions.emptyTemplateData()),
});

export default connect(mapStoreToProps, mapDispatchToProps)(Notes);
